import React, { useState } from "react";
import { useAppDispatch } from "../../app/hooks";
import { addToDo, updateToDo } from "./todoSlice";
// import AddIcon from "@mui/icons-material/Add";

interface ToDoType {
  PK: string;
  SK: string;
  title: string;
  description?: string;
  completed: boolean;
  type: string;
}
interface Props {
  type: "new" | "edit";
  todo?: ToDoType;
  close: () => void;
}

function AddToDo({ type, todo, close }: Props) {
  const dispatch = useAppDispatch();

  const [formData, setFormData] = useState({
    title: todo?.title || "",
    description: todo?.description || "",
  });
  const [error, setError] = useState({
    title: "",
    description: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError({ ...error, title: "", description: "" });
    console.log(formData);
    if (type === "new") {
      await dispatch(addToDo(formData));
      setFormData({ title: "", description: "" });
    } else {
      const { SK, completed } = todo!;
      await dispatch(updateToDo({ ...formData, SK, completed }));
    }
    setIsSubmitting(false);
  };

  return (
    <div className="modal-backdrop" onClick={() => close()}>
      <div
        className="modal addToDo"
        onClick={(e) => {
          // do not close modal if anything inside modal content is clicked
          e.stopPropagation();
        }}
      >
        <button className="close" onClick={() => close()}>
          X
        </button>
        <h2>{type === "new" ? "AddToDo" : "Update Todo"}</h2>
        <form autoComplete="off" onSubmit={handleSubmit}>
          <input
            required
            type="text"
            placeholder="Title"
            name="title"
            onChange={handleChange}
            value={formData.title}
            minLength={1}
            maxLength={100}
          />
          <input
            type="text"
            placeholder="Description"
            name="description"
            onChange={handleChange}
            value={formData.description}
            minLength={1}
            maxLength={1000}
          />
          <button className="btn-primary" disabled={isSubmitting} type="submit">
            {type === "new" ? "Add" : "Update"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AddToDo;
